<script>
import i18n from '@/i18n';
import Swal from 'sweetalert2';
import Multiselect from '@/components/Multiselect/main.vue';

import { authComputed, authFackMethods, masterMethods } from '@/state/helpers';
import { NAMEROLEFIXED } from '@/config/constants';
import { clearInfoUser } from '@/api/handler/main';
import { checkPermission, getInfoUserLocalStorage } from '@/utils/handlers';
import { isRolePartner } from '@/views/pages/require/handlers';

export default {
    components: { Multiselect },
    data() {
        return {
            current_language: 'ja',
            isShowProfile: true,
            campaignObject: null,
            listDataMasterCampaign: [],
            configDefaultCampaign: {
                error: false,
                isRemove: true,
                trackBy: 'id',
                label: 'name',
                loading: false
            },
            isRolePartner: isRolePartner()
        };
    },
    computed: {
        ...authComputed,
        resultRole() {
            return NAMEROLEFIXED.find((item) => this.currentUser && this.currentUser.role && item.id === this.currentUser.role.id);
        }
    },
    mounted() {
        if (this.currentUser.role && document.getElementById('page-topbar')?.style) {
            switch (this.currentUser.role.name) {
                case 'part_time':
                    document.getElementById('page-topbar').style.backgroundColor = '#fbbc04';
                    break;
                case 'administrator':
                case 'sale':
                case 'instructor':
                case 'sale_instructor':
                    document.getElementById('page-topbar').style.backgroundColor = '#ea4335';
                    break;
                case 'partner':
                case 'partner_contact':
                case 'partner_secretariat':
                case 'partner_shipping':
                case 'partner_secretariat_shipping':
                    document.getElementById('page-topbar').style.backgroundColor = '#4285f4';
                    this.isShowProfile = false;
                    break;
            }
        }
        this.campaignObject = {
            campaign_id: this.currentUser && this.currentUser.default_campaign ? this.currentUser.default_campaign.id : '',
            id: this.currentUser && this.currentUser.default_campaign ? this.currentUser.default_campaign.id : '',
            name: this.currentUser && this.currentUser.default_campaign ? this.currentUser.default_campaign.name : ''
        };
        this.getListMasterCampaign();
    },
    methods: {
        checkPermission,
        ...authFackMethods,
        ...masterMethods,

        logoutUser() {
            Swal.fire({
                title: 'ログアウトしてもよろしいでしょうか。',
                text: '',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#34c38f',
                cancelButtonColor: '#e8ecf4',
                confirmButtonText: 'OK',
                cancelButtonText: 'キャンセル'
            }).then((result) => {
                if (result.value) {
                    this.logout().then(() => {
                        clearInfoUser();
                        localStorage.clear();
                        this.$router.push('/login');
                    });
                }
            });
        },
        toggleMenu() {
            this.$parent.toggleMenu();
        },
        initFullScreen() {
            document.body.classList.toggle('fullscreen-enable');
            if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        },
        toggleRightSidebar() {
            this.$parent.toggleRightSidebar();
        },
        setLanguage(locale) {
            i18n.locale = locale;
            this.current_language = i18n.locale;
        },
        handleGoToEditProfile() {
            if (this.$route.path == '/employee/form' && this.$route.query.id == this.currentUser.id) return;
            this.$router.push({ path: '/employee/form', query: { id: this.currentUser.id } });
        },

        setDefault() {
            if (this.configDefaultCampaign.loading) return;
            this.configDefaultCampaign.loading = true;
            let object = JSON.parse(JSON.stringify(this.campaignObject));
            object.campaign_id = object?.id ? object.id : '';
            this.setDefaultCampaign(object).then((data) => {
                if (data.code == 200) {
                    this.profile();
                    if (['Documents', 'LandingPageCreate', 'ManagerFormCreate', 'ManagerFormEdit'].includes(this.$route.name)) {
                        setTimeout(() => {
                            window.location.reload();
                        }, 200);
                    }
                }
                this.configDefaultCampaign.loading = false;
            });
        },

        handleGetDetail() {
            if (this.$route.path == '/campaign/form/view') {
                window.location.href = `${window.location.origin}/campaign/form/view?id=${this.campaignObject.id}`;
            } else {
                this.$router.push({
                    path: '/campaign/form/view',
                    query: {
                        id: this.campaignObject.id
                    }
                });
            }
        },

        getListMasterCampaign() {
            let query = '';
            if (this.isRolePartner) {
                query = `?has[partner]=${getInfoUserLocalStorage().partner_id ?? ''}`;
            }
            this.getAllDocuments(query).then((data) => {
                if (data.code == 200) {
                    this.listDataMasterCampaign = data.data;
                }
            });
        }
    }
};
</script>

<template>
    <header id="page-topbar">
        <div class="navbar-header" style="justify-content: unset">
            <div class="d-flex">
                <!-- LOGO -->
                <div class="navbar-brand-box">
                    <a href="/" class="logo logo-dark">
                        <span class="logo-sm">
                            <img src="@/assets/images/logo-paldia.png" alt height="22" />
                        </span>
                        <span class="logo-lg">
                            <img src="@/assets/images/logo-paldia.png" alt height="20" />
                        </span>
                    </a>

                    <a href="/" class="logo logo-light">
                        <span class="logo-sm">
                            <img src="@/assets/images/logo-paldia-new.png" alt height="22" class="w-full" style="margin-left: 5px" />
                        </span>
                        <span class="logo-lg">
                            <img src="@/assets/images/logo-paldia-new.png" alt height="20" style="margin-left: 20px" />
                        </span>
                    </a>
                </div>

                <button @click="toggleMenu" type="button" class="btn btn-sm px-3 font-size-24 header-item waves-effect" id="vertical-menu-btn">
                    <i class="ri-menu-2-line align-middle text-white"></i>
                </button>
            </div>
            <div class="col-sm-6 p-1 rounded" style="background-color: #ffffff">
                <div class="d-flex align-items-center">
                    <div class="col-sm-1" style="min-width: fit-content">
                        <label class="mb-0"> {{ $t('pageCampaign.defaultCampaign') }}</label>
                    </div>
                    <div class="flex-fill mr-2">
                        <Multiselect
                            :id="`select-set-campaign-default`"
                            :value.sync="campaignObject"
                            :options="listDataMasterCampaign"
                            :config="configDefaultCampaign"
                            @select="setDefault()"
                        />
                    </div>
                    <div class="ml-auto" style="min-width: fit-content">
                        <button v-if="checkPermission('campaign.view')" type="button" @click="handleGetDetail" class="btn btn-common-sml btn-info">
                            <i class="ri-file-list-2-line"></i>{{ $t('btn.detail') }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column align-items-end ml-auto">
                <b-dropdown right variant="black" toggle-class="header-item" class="d-inline-block user-dropdown text-right custom-dropdown">
                    <template v-slot:button-content>
                        <div style="text-align: right">
                            <div class="d-flex align-items-end text-white">
                                <span class="d-xl-inline-block ml-1 text-left" style="white-space: pre-line">{{ resultRole?.text }}: </span>
                                <span class="d-xl-inline-block ml-1">{{ currentUser ? currentUser.name : '' }}</span>
                                <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                            </div>
                        </div>
                    </template>
                    <a v-if="isShowProfile" class="dropdown-item" href="javascript:void(0)" @click="handleGoToEditProfile()">
                        <i class="ri-user-line align-middle mr-1"></i>
                        {{ $t('common.inforUser') }}
                    </a>
                    <a class="dropdown-item" href="javascript:void(0)" @click="logoutUser()">
                        <span>
                            <i class="ri-shut-down-line align-middle mr-1"></i>
                            {{ $t('common.logout') }}
                        </span>
                    </a>
                </b-dropdown>
            </div>
        </div>
    </header>
</template>

<style lang="scss" scoped>
.notify-item {
    .active {
        color: #16181b;
        background-color: #f8f9fa;
    }
}
</style>

<style lang="scss">
.custom-dropdown {
    button.btn {
        height: 100%;
    }
}
</style>
